import React, { useState, useEffect } from 'react';
import parse from "html-react-parser";
import { useStyles } from "../styles/styles";
import { getDecimal } from "../global/utils";
import Grid from '@mui/material/Grid';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import Typography from "@mui/material/Typography";
import ListItemText from '@mui/material/ListItemText';
import FormControlLabel from '@mui/material/FormControlLabel';
import RadioGroup from '@mui/material/RadioGroup';
import Radio from '@mui/material/Radio';

const OptionList = (props) => {
    const options = props.options;
    const balance = props.balance;
    const setPayIneligible = props.setPayIneligible;
    const onSelect = props.onSelect;
    const court = props.court;
    const classes = useStyles;
    const [option, setOption] = useState(null);
    const optionValue = props.selectedOption !== undefined ? props.selectedOption : option;

    useEffect(() => {
        balance.trafficSchoolId = option;
        if (option) {
            const opts = options.filter(o => o.optionId === option);
            if (opts && opts.length > 0) {
                balance.trafficSchoolType = opts[0].optionType;
                setPayIneligible(balance.refId);
            } else {
                balance.trafficSchoolType = null;
                setPayIneligible(null);
            }
        } else {
            balance.trafficSchoolType = null;
            setPayIneligible(null);
        }
        if (onSelect) onSelect(option);
    }, [option])

    return (
        <>
            <List sx={{...classes.list, maxHeight: '100%', marginLeft: '1rem'}} >
                <ListItem alignItems='flex-start' sx={classes.listPadding}>
                    <ListItemText
                        sx={classes.listText}
                        primary={
                            <Grid
                                container
                                spacing={1}
                                alignItems="top"
                            >
                                <Grid item xs={12} md={4}><Typography variant='subtitle2' sx={classes.title}>{court.optionHeader ?? 'Option(s)'}</Typography></Grid>
                                <Grid item xs={12} md={8}><Typography variant='subtitle2' sx={classes.title}>
                                    {court.optionInstructions ? parse(court.optionInstructions) : ''}
                                </Typography></Grid>
                                <Grid item xs={3}>&nbsp;</Grid>
                                <Grid item xs={6} sx={{fontWeight: 'bold'}} >Description</Grid>
                                <Grid item xs={3} sx={{paddingLeft: '1rem', fontWeight: 'bold'}}>Amount</Grid>
                            </Grid>
                        }
                        primaryTypographyProps={{
                            component: 'span',
                            color: 'textPrimary',
                            sx: {fontSize: '.9rem', lineHeight: '.7rem'},
                        }}
                    />
                </ListItem>
                <RadioGroup name='trafficSchool' onChange={(e) => {setOption(e.target.value); if (onSelect) onSelect(e.target.value);}} value={optionValue}>
                    <>
                        { options && options.length > 0 && options.map((opt) => {
                            return (
                                <ListItem alignItems='flex-start' disableGutters sx={{paddingTop: '0', paddingBottom: '0'}}>
                                    <ListItemText
                                        sx={classes.listText}
                                        primary={
                                            <Grid
                                                container
                                                spacing={1}
                                                alignItems="top"
                                            >
                                                <Grid item xs={3}>
                                                    <FormControlLabel
                                                        value={opt.optionId}
                                                        control={
                                                            <Radio
                                                                size='small'
                                                                defaultChecked={false}
                                                                sx={{marginLeft: '1rem', paddingBottom: '0', paddingLeft: '.5rem', paddingTop: '0', position: ''}}
                                                            />
                                                        }
                                                        label=''
                                                        aria-label='select traffic school option'
                                                        sx={{paddingLeft: '0', paddingTop: '0'}}
                                                    />
                                                </Grid>
                                                <Grid item xs={6}>
                                                    {court.optionHeader ? '' : "Traffic School - "}{opt.optionDescription ? opt.optionDescription : opt.optionTypeDescription}
                                                </Grid>
                                                <Grid item xs={3} sx={{textAlign: 'right', paddingRight: {xs: '5%', sm: '14%', lg: '21%'}}}>{getDecimal(opt.optionAmount)}</Grid>
                                            </Grid>
                                        }
                                        primaryTypographyProps={{
                                            component: 'span',
                                            color: 'textPrimary',
                                            sx: {fontSize: '.9rem', paddingLeft: '.2rem'}
                                        }}
                                    />
                                </ListItem>
                            );
                        })}
                    </>
                </RadioGroup >
            </List>
        </>
    );
}

export default OptionList;
